import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./VisitDelicioz.css";

const VisitDelicioz = () => {
  return (
    <div className="visit-delicioz">
      <Row className="gx-0 d-flex justify-content-center align-items-center">
        <Col xs={11} md={6} className="d-flex justify-content-center align-items-center py-5 py-md-0">
          <div className="text-center">
            <div className="visit-content big_fonts_opti_visit">
              <h2>Visite LE SONARGA</h2>
              <h2>Restaurant</h2>
              <p>ATTENDRE ICI</p>
            </div>
            <div className="py-3 booking-content big_fonts_opti_visit_number">
              <p className="m-0 ">Demande De Réservation</p>
              <h2>05 67 48 47 33</h2>
            </div>
            <div className="location-content">
              <h3>Emplacement</h3>
              <p>
              LE SONARGA Restaurant & Gastronomie,
                <br />
                124 Rue Jean Adoué 31800 Saint-Gaudens, France
              </p>
            </div>
          </div>
        </Col>

        <Col xs={11} md={6} className="pb-5 pb-md-0">
          <div className="mapouter">
            <div className="gmap_canvas">
              <iframe
                className="w-100"
                height="570px"
                title="g-map"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=124%20Rue%20Jean%20Adou%C3%A9%2031800%20Saint-Gaudens&t=&z=13&ie=UTF8&iwloc=&output=embed"
              ></iframe>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default VisitDelicioz;
